const KEY_PREFIX = 'zenity_filters';

export class FilterStorage {
  static save(routeSegment: string, q: string, tab?: string): void {
    const key = this._buildKey(routeSegment, tab);
    sessionStorage.setItem(key, q);
  }

  static load(routeSegment: string, tab?: string): string | null {
    const key = this._buildKey(routeSegment, tab);
    return sessionStorage.getItem(key);
  }

  static clearAll(): void {
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key?.startsWith(KEY_PREFIX)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  }

  private static _buildKey(routeSegment: string, tab?: string): string {
    return tab ? `${KEY_PREFIX}:${routeSegment}:${tab}` : `${KEY_PREFIX}:${routeSegment}`;
  }
}
